import { createApp } from 'vue'
import Calendar from '../components/calendar.vue'
import WeeklyCalendar from '../components/weekly-calendar.vue'

// The grid the month and week views share, serialized into the page once (see special_events/calendar).
const calendarPayload = () => {
  const el = document.getElementById('calendar-payload')

  return el ? JSON.parse(el.textContent) : {}
}

const mountCalendar = (el) => {
  if (!document.querySelector(el)) {
    return
  }

  const payload = calendarPayload()

  const app = createApp({
    components: {
      Calendar,
      weekview: WeeklyCalendar
    },
    data () {
      return {
        calendarView: 'month',
        allDay: true,
        datesData: payload.datesData || null,
        person: payload.person || null
      }
    }
  })

  app.mount(el)
}

const mountMobileMenuToggle = () => {
  const $toggle = document.getElementById('mobile-menu-toggle')
  const $menu = document.getElementById('mobile-menu')

  $toggle.addEventListener('click', () => {
    if ($menu.className.indexOf('block') !== -1) {
      $menu.className = $menu.className.replace('block', 'hidden')
    } else {
      $menu.className = $menu.className.replace('hidden', 'block')
    }
  })
}

const dataConfirm = () => {
  document.querySelectorAll('[data-confirm]').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (!confirm(el.getAttribute('data-confirm'))) {
        event.preventDefault()
        event.stopImmediatePropagation()

        return false
      }
    })
  })
}

const mountFlashDismiss = () => {
  document.querySelectorAll('[data-flash-dismiss]').forEach((el) => {
    el.addEventListener('click', () => {
      const alert = el.closest('[role="alert"]')
      if (alert) {
        alert.remove()
      }
    })
  })
}

mountCalendar('#vue-wrapper')
mountMobileMenuToggle()
dataConfirm()
mountFlashDismiss()
